package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import org.moxultimate.topwithmox.wallpaper.panorama.PanoramaScreen

/**
 * Panorama
 * Fullscreen 360° panorama viewer page — no header or footer.
 * Opened in a new tab from the Wallpaper Details page.
 */
@InitRoute
fun initPanoramaRoute(ctx: InitRouteContext) {
    // No PageLayoutData needed — this page uses no layout wrapper.
}

@Page(routeOverride = "panorama")
@Composable
fun PanoramaRoute() {
    PanoramaScreen()
}
